import { html, View } from 'rune-ts';
import klass from './PortfolioSection.module.scss';

interface PortfolioCardProps {
  imageUrl: string;
}
export class PortfolioCard extends View<PortfolioCardProps> {
  override template({ imageUrl }: PortfolioCardProps) {
    return html`
      <div class="${klass.portfolio_card}">
        <img src="${imageUrl}" alt="랜딩페이지 포트폴리오 이미지" class="${klass.portfolio_image}" />
      </div>
    `;
  }
}
